//const mobileSearchbar= document.getElementById("#shopify-section-sections--21663835160867__theme_header > nav > div > div.md\:hidden.flex.flex-wrap.items-center.py-2.window > div.no-js--hide.flex-grow.w-full.pt-2 > form > div");

function showSearchBar() {
  
   document.getElementsByClassName("search_mobile2")[0].style.display="block";
 
  
       
}